import React from 'react'
import { PurchaseContext } from '../contexts/PurchaseContext'
import families from '../data/productFamilies';

import { customObjectSort } from '../../common/js/sort-utility';
import { type FamilySettings } from '../../common/js/webshop-product-utility';

const familyList = families;
const SORT_ORDER = [
    'Boris FX Suite', 'Sapphire', 'Continuum', 'Mocha Pro', 'Silhouette', 'Optics', 'CrumplePop', 'SynthEyes' 
]
const legacyFamilies = [
    'Training Products', 'Presets and Templates' 
];
const sortedFamilies = customObjectSort(families, 'title', SORT_ORDER);

type Props = {
    isLegacy: boolean
}

export default function CollectionSelect({isLegacy}: Props) {
    const [state, setState] = React.useContext(PurchaseContext);

    const handleCollectionChange = (event: React.MouseEvent<HTMLAnchorElement>) => {
        event.preventDefault();
        const data = event.currentTarget.dataset;
        const stateNew ={...state};
        const family = findFamilyByName(data.family);
        if(!family) return;
        stateNew.family = family.title;
        stateNew.defaults = family.defaults;
        setState(stateNew);
    }

    const listItems: React.JSX.Element[] = [];
    sortedFamilies.forEach(f => {
        if (isLegacy && !legacyFamilies.includes(f.title)){
            return;
        }
        const isSelected = state.familyName == f.title;
        const linkClass = isSelected ? 'collection-option selected' : 'collection-option';
        listItems.push(
            <React.Fragment key={f.id}>
                <li className='collection-list-item'>
                    <a href='#' data-family={f.title} onClick={state.loading ? null : handleCollectionChange} className={linkClass}>
                        {f.title}
                    </a>
                </li>
                <hr className='collection-divider' />
            </React.Fragment>
        )
        
    })

    return (
        <div className='text-center' id='navContainer'>
            <div style={{ position: 'sticky', top: '115px' }}>
                <h4 id='navTitle'>Products</h4>
                <ul className='list-unstyled' style={{fontSize: '10pt !important'}} id='navStore'>
                    {listItems}
                </ul>
            </div>
        </div>
    )
}

const findFamilyByName = (name: string) => {
    const collection = families.find(item => {
        return name == item.title;
    });
    return collection;
}